import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface PrescriberDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllPrescriberDetails?: any;
}
let initialState: PrescriberDetails = {
  isLoading: false,
  error: false,
  message: null,
  AllPrescriberDetails: {},
};
const PrescriberDetailsSlice = createSlice({
  name: "PrescriberDetails",
  initialState,
  reducers: {
    loadingPrescriberDetails: (
      state: PrescriberDetails,
      action: PayloadAction
    ) => {
      state.isLoading = true;
    },
    setPrescriberDetails: (
      state: any,
      action: PayloadAction<PrescriberDetails>
    ) => {
      return action.payload;
    },
    clearPrescriberData: (state: PrescriberDetails, action: PayloadAction) => {
      state.AllPrescriberDetails = {};
      state.isLoading = false;
      state.error = false;
      state.message = null;
    },
  },
});

export const {
  loadingPrescriberDetails,
  setPrescriberDetails,
  clearPrescriberData,
} = PrescriberDetailsSlice.actions;

export default PrescriberDetailsSlice.reducer;
